<template>
  <div class="bodyDiv" id="load-progress" role="progressbar">
    <div class="content">
      <div class="row">
        <div class="col-12">
          <img src="https://silkplm.com/wp-content/uploads/2024/07/Maintenance-8.png" alt="Maintenance Image"
               class="maintenance-image"/>
        </div>
      </div>
      <div class="row mt-3 justify-content-center">
        <div class="col-md-6 col-lg-4 mb-3 d-flex justify-content-center">
          <div class="p-3">
            <p class="top-text mt-3 mb-3">System Under Maintenance</p>
            <p class="middle-text pr-1 pl-1">We sincerely apologize for the inconvenience.<br>
              Our system is currently undergoing scheduled maintenance and upgrades, but will return shortly.</p>
            <p class="bottom-text mt-2 mb-2">Thank you for your patience</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-3 d-flex justify-content-center">
          <div class="p-3">
            <p class="top-text mt-3 mb-3">System w trakcie konserwacji</p>
            <p class="middle-text pr-1 pl-1">Serdecznie przepraszamy za niedogodności.<br>
              Nasz system przechodzi obecnie planową konserwację i aktualizacje, ale wkrótce powróci do działania.</p>
            <p class="bottom-text mt-2 mb-2">Dziękuję za Twoją cierpliwość</p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4 mb-3 d-flex justify-content-center">
          <div class="p-3">
            <p class="top-text mt-3 mb-3">System wird gewartet</p>
            <p class="middle-text pr-1 pl-1">Wir entschuldigen uns aufrichtig für die Unannehmlichkeiten.<br>
              An unserem System werden derzeit planmäßige Wartungsarbeiten und Upgrades durchgeführt, es wird aber in
              Kürze
              wieder verfügbar sein.</p>
            <p class="bottom-text mt-2 mb-2">Vielen Dank für Ihre Geduld</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenanceView",
  components: {},

  props: {
    title: String,
    messageNo1: String,
    messageNo2: String,
    messageNo3: String,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
}
</script>

<style scoped>
.bodyDiv {
  margin: 0;
  padding: 0;
  background-image: url("https://silkplm.com/wp-content/uploads/2024/05/Background.svg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.content {
  color: white;
  padding: 20px;
}

@media screen and (max-width: 900px) {
  .maintenance-image {
    width: 70vw;
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 900px) {
  .maintenance-image {
    width: 35vw;
    margin-bottom: 20px;
  }
}

.top-text {
  font-size: clamp(1.8rem, 1.8rem, 2.2rem);
  font-weight: bold;
}

.middle-text {
  font-size: clamp(0.8rem, 1rem, 1rem);
  margin: 10px 0;
}

.bottom-text {
  font-size: clamp(0.8rem, 1rem, 1rem);
  font-weight: bold;
}
</style>
